const faqItems = [
  {
    q: '布丁漫画的下拉式阅读是什么？',
    a: '下拉式阅读是布丁漫画独创的漫画观看模式，整话漫画以纵向连续排列的方式呈现，你只需向下滑动即可流畅阅读，无需频繁点击翻页按钮。这种模式特别适合手机端阅读，让你的漫画观看体验不卡顿、一气呵成。',
  },
  {
    q: '布丁漫画是否需要付费？',
    a: '不需要！布丁漫画目前所有漫画资源均免费提供阅读，无需购买会员或付费订阅。我们致力于为漫画爱好者提供免费的下拉式漫画观看体验，韩漫、国漫、日漫全集都可以免费在线追更。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '布丁漫画的热门连载作品保持与官方同步更新，大部分热门漫画每日或每周定期更新。你可以通过收藏功能关注喜欢的作品，更新后第一时间收到提醒，不错过任何一话新内容。',
  },
  {
    q: '如何在手机上获得最佳阅读体验？',
    a: '布丁漫画网页版已全面适配移动端，在手机浏览器中打开即可享受流畅的下拉式阅读。建议使用Chrome或Safari等现代浏览器访问，开启屏幕旋转锁定后竖屏阅读效果最佳。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              常见问答
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              关于布丁漫画下拉式阅读的常见问题与解答
            </p>
          </div>

          <div className="space-y-4">
            {faqItems.map((item, i) => (
              <div
                key={i}
                className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <div className="p-5 md:p-6">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-3 flex items-start gap-3">
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 text-xs font-bold mt-0.5">
                      Q
                    </span>
                    {item.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                    {item.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}